import { Inline, Stack, Text } from 'braid-design-system';
import type { ReactNode } from 'react';

interface FieldHeadingProps {
  heading: string | ReactNode;
  secondaryHeading?: string;
  subHeading?: string;
}

export const FieldHeading = ({
  heading,
  secondaryHeading,
  subHeading,
}: FieldHeadingProps) => (
  <Stack space="xsmall">
    <Inline space="xxsmall">
      <Text weight="strong">{heading}</Text>
      {secondaryHeading ? (
        <Text tone="secondary">({secondaryHeading})</Text>
      ) : null}
    </Inline>
    {subHeading ? <Text tone="secondary">{subHeading}</Text> : null}
  </Stack>
);
